export default "__VITE_ASSET__DpSqU7yL__"